// moneyFormatter.js
const formatMoney = (cents, format) => {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const currency = window?.Shopify?.currency?.active || "INR";

  const currencySymbols = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    INR: "RS.",
    AUD: "$",
    CAD: "$"
  };

  const symbol = currencySymbols[currency] || currency;

  const formatString = `${symbol}{{amount}}`;

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    const showZeros = window.themeSettings?.priceWithTrailingZero;

    if (showZeros) {
      number = (number / 100.0).toFixed(2); // always 2 decimals
    } else {
      number = (number / 100.0).toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
    }

    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  let value = '';

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

export default formatMoney;
